import { memo } from 'react';

function Caret({
	active = false,
	className = '',
}: {
	active?: boolean;
	className?: string;
}) {
	const fill = active ? '#607efe' : '#787878';

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="11"
			height="7"
			fill="none"
			viewBox="0 0 11 7"
			className={className}
		>
			<path
				d="M5.49785 6.60938L0.394561 0.88372L10.6011 0.883719L5.49785 6.60938Z"
				fill={fill}
			/>
		</svg>
	);
}

export default memo(Caret);
